import React from "react";
import { DOC_ISSUE_LABELS } from "../utils/constants";
import { documentationIssuesOf } from "../utils/queueUtils";
import CareWatchPreviewCard, { CareWatchPreviewRow } from "./CareWatchPreviewCard";

const NOTE_GUIDANCE_WORDS = 8;

const noteCountLabel = (words) => {
  const count = Number(words) || 0;
  if (count === 0) return "No note recorded";
  if (count < NOTE_GUIDANCE_WORDS) return `${count} words · below guidance`;
  return `${count} words`;
};

const peopleOnShift = (item) => {
  const people = Array.isArray(item.participantDocumentation)
    ? item.participantDocumentation.filter((person) => person && person.name)
    : [];
  return people.length > 1 ? people : [];
};

const PersonLines = ({ people, line }) => (
  <ul className="care-watch-doc-check__lines">
    {people.map((person, index) => (
      <li key={`${person.name}-${index}`}>{line(person)}</li>
    ))}
  </ul>
);

const CareWatchDocCheck = ({ item }) => {
  const action = String(item.action || "").trim();
  const people = peopleOnShift(item);

  return (
    <CareWatchPreviewCard
      title="Documentation check"
      className="care-watch-doc-check"
      // hint="Acknowledge when corrected"
    >
      <CareWatchPreviewRow label="Issue">
        {documentationIssuesOf(item)
          .map((issue) => DOC_ISSUE_LABELS[issue])
          .filter(Boolean)
          .join(", ") || "Incomplete note"}
      </CareWatchPreviewRow>
      <CareWatchPreviewRow label="Note length">
        {people.length > 0 ? (
          <PersonLines
            people={people}
            line={(person) => `${person.name}: ${noteCountLabel(person.noteWords)}`}
          />
        ) : (
          noteCountLabel(item.noteLength)
        )}
      </CareWatchPreviewRow>
      <CareWatchPreviewRow label="Goals">
        {people.length > 0 ? (
          <PersonLines
            people={people}
            line={(person) =>
              `${person.name}: ${person.goalsReferenced ? "Referenced" : "Not referenced"}`
            }
          />
        ) : item.goalsReferenced ? (
          "Referenced"
        ) : (
          "Not referenced"
        )}
      </CareWatchPreviewRow>
      {action ? (
        <CareWatchPreviewRow label="Action">{action}</CareWatchPreviewRow>
      ) : null}
    </CareWatchPreviewCard>
  );
};

export default CareWatchDocCheck;
